import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { currentEnvironment } from '@/config/envConfig';
let DashboardService = class DashboardService {
    constructor(dashboardApi, authService) {
        this.dashboardApi = dashboardApi;
        this.authService = authService;
    }
    get userId() {
        const userIdConfig = {
            qa: 'f86c3976784746739420a3680f86545e',
            cn: 'd7576acfc9334d3fad02a8964045230a',
            release: '8542034ad4ba496fb8482565d37ec409',
            eu: '7e1683521ae04925918e14f0dca77878',
            us: '6a8b69b2f9394f7a8c3944bfae9f3625',
            ci: '7bb4bb620ec64d6388fb73f7fdc23eb7',
        };
        return userIdConfig[currentEnvironment || 'ci'];
    }
    getDashboardInfo(params) {
        return this.dashboardApi.getDashboardInfo({
            user_id: this.userId,
            ...params,
        }).then(data => data.data);
    }
    getDashboardInfoStatus(params) {
        return this.dashboardApi.getDashboardInfoStatus(params);
    }
};
DashboardService = __decorate([
    injectable(),
    __param(0, inject(Symbols.DashboardApi)),
    __param(1, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object])
], DashboardService);
export { DashboardService };
